const state = {
  isLoading: false,
  loggedIn: false,
  data: null,
  showTermsDialog: false,
  ssoCheck: {},
  mdmBoostrap: null,
  dieselPeg: {},
  cngPeg: {},
  fcmToken: '',
  environmentVariables: {},
  logo: '',
  isPaymentError: false,
};

export default state;
